module.exports = __webpack_public_path__ + "static/media/checkBoxSelected.06834458.svg";